import PartnershipXLSX from "@assets/templates/Bulk_Partnership_Absolute_Value_Percentage.xlsx";
import AbsoluteXLSX from "@assets/templates/Bulk_Sales_Absoulte_Value_Product_Template_File.xlsx";
import ProductXLSX from "@assets/templates/Bulk_Sales_Percentage_Template_File.xlsx";
// import PercentageMerchantXLSX from "@assets/templates/Merchant_Percentage_Sales_Product_Template_File.xlsx";
import PercentagePartnerXLSX from "@assets/templates/Partnership_Percentage_Sales_Product_Template_File.xlsx";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DeleteIcon from "@material-ui/icons/Delete";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
// import Typography from "@material-ui/core/Typography";
// import ConfirmButton, {
//   ConfirmButtonTransitionState
// } from "@saleor/components/ConfirmButton";
// import { MultiAutocompleteChoiceType } from "@saleor/components/MultiAutocompleteSelectField";
// import useForm, { FormChange } from "@saleor/hooks/useForm";
// import useModalDialogErrors from "@saleor/hooks/useModalDialogErrors";
// import useModalDialogOpen from "@saleor/hooks/useModalDialogOpen";
// import useWizard from "@saleor/hooks/useWizard";
import { buttonMessages } from "@saleor/intl";
import { DialogProps } from "@saleor/types";
// import {
//   ExportProductsInput,
//   ExportScope,
//   FileTypesEnum
// } from "@saleor/types/globalTypes";
// import getExportErrorMessage from "@saleor/utils/errors/export";
// import { toggle } from "@saleor/utils/lists";
// import { mapNodeToChoice } from "@saleor/utils/maps";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";

// const initialForm: ExportProductsInput = {
//   exportInfo: {
//     attributes: [],
//     fields: [],
//     warehouses: []
//   },
//   fileType: FileTypesEnum.XLSX,
//   scope: ExportScope.ALL
// };

const useStyles = makeStyles(
  {
    descriptionLabel: {
      margin: "5px 0px 5px 0px"
    },
    fileUploadField: {
      height: "175px",
      paddingTop: "20px",
      textAlign: "center"
    },
    root: {
      display: "flex"
    }
  },
  { name: "SalesBulkUploadDialog" }
);

export interface SalesBulkUploadDialogProps extends DialogProps {
  action: string;
  loading: boolean;
  onFileError: () => void;
  onSubmit: (file: any, isOverwrite: boolean) => void;
}

const SalesBulkUploadDialog: React.FC<SalesBulkUploadDialogProps> = props => {
  const { action, onClose, onFileError, open, onSubmit, loading } = props;

  const classes = useStyles(props);
  const upload = React.useRef(null);
  const intl = useIntl();

  const [getFile, setFile] = useState(null);
  const [isOverwrite, setIsOverwrite] = useState(
    action !== "uploadSalesProduct"
  );

  useEffect(() => {
    if (!open) {
      setFile(null);
    }
  }, [open]);

  const headerText = thisAction => {
    switch (thisAction) {
      case "uploadSalesMerchantAbsolute":
        return (
          <FormattedMessage
            defaultMessage="Bulk Merchant Absolute Value"
            description="import product sales to csv file, dialog header"
          />
        );
      case "uploadSalesPartnerAbsolute":
        return (
          <FormattedMessage
            defaultMessage="Bulk Partnership Absolute Value"
            description="import product sales to csv file, dialog header"
          />
        );
      case "uploadSalesPartnerPercentage":
        return (
          <FormattedMessage
            defaultMessage="Bulk Partnership Percentage"
            description="import product sales to csv file, dialog header"
          />
        );
      default:
        return (
          <FormattedMessage
            defaultMessage="Bulk Merchant Percentage"
            // defaultMessage="Bulk Sale Percentage Value"
            description="import product sales to csv file, dialog header"
          />
        );
    }
  };

  const createLink = thisAction => {
    // let message =
    //   "Download a {link} template file for bulk merchant sales percentage.";
    // let thisLink = PercentageMerchantXLSX;
    // let filename = "Bulk_Sales_Merchant_Percentage_Template_File.xlsx";
    let message = "Download a {link} template file for bulk sales percentage.";
    let thisLink = ProductXLSX;
    let filename = "Bulk_Sales_Percentage_Template_File.xlsx";
    switch (thisAction) {
      case "uploadSalesMerchantAbsolute":
        thisLink = AbsoluteXLSX;
        filename = "Bulk_Merchant_Absolute_Value_Product_Template_File.xlsx";
        message =
          "Download a {link} template file for bulk merchant absolute value.";
        break;
      case "uploadSalesPartnerAbsolute":
        thisLink = PartnershipXLSX;
        filename = "Bulk_Partnership_Absolute_Value_Product_Template_File.xlsx";
        message =
          "Download a {link} template file for bulk partnership absolute value.";
        break;
      case "uploadSalesPartnerPercentage":
        thisLink = PercentagePartnerXLSX;
        filename = "Bulk_Sales_Partnership_Percentage_Template_File.xlsx";
        message =
          "Download a {link} template file for bulk partnership sales percentage.";
        break;
    }
    return (
      <FormattedMessage
        id="text"
        defaultMessage={message}
        values={{
          link: (
            <a href={thisLink} download={filename} id="excelDownloadlink">
              <FormattedMessage defaultMessage="xlsx" />
            </a>
          )
        }}
      />
    );
  };

  const checkFile = e => {
    if (
      e[0].type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      onFileError();
    } else {
      setFile(e[0]);
    }
  };

  const handleClose = () => {
    onClose();
    setFile(null);
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth="sm"
      fullWidth
      disableBackdropClick={loading}
    >
      <>
        <DialogTitle>{headerText(action)}</DialogTitle>
        <DialogContent>
          {createLink(action)}
          {action === "uploadBulkProduct" && (
            <ControlledCheckbox
              id="overwriteCheckbox"
              name={"overwrite"}
              label={intl.formatMessage({
                defaultMessage: "Overwrite existing products",
                description: "check to require attribute to have value"
              })}
              checked={isOverwrite}
              onChange={() => setIsOverwrite(!isOverwrite)}
            />
          )}
          {getFile ? (
            <Paper>
              <List>
                <ListItem>
                  {getFile.name}
                  <ListItemSecondaryAction>
                    <IconButton
                      id="deleteFileBtn"
                      edge="end"
                      aria-label="delete"
                      onClick={() => setFile(null)}
                    >
                      {loading ? (
                        <CircularProgress size={16} />
                      ) : (
                        <DeleteIcon />
                      )}
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              </List>
            </Paper>
          ) : (
            <Dropzone onDrop={checkFile}>
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <Paper
                    className={classes.fileUploadField}
                    onClick={() => upload.current.click()}
                  >
                    <input
                      {...getInputProps()}
                      id="fileUpload"
                      accept=".xlsx"
                      onChange={e => checkFile(e.target.files)}
                      ref={upload}
                      type="file"
                    />
                    <CloudUploadIcon fontSize="large" />
                    <p className={classes.descriptionLabel}>
                      <FormattedMessage
                        defaultMessage="Drag and Drop Files"
                        description="description"
                      />
                    </p>
                    <p className={classes.descriptionLabel}>
                      <FormattedMessage
                        defaultMessage="Or"
                        description="description"
                      />
                    </p>
                    <Button
                      color="primary"
                      variant="contained"
                      id="uploadFileBtn"
                    >
                      <FormattedMessage
                        defaultMessage="Upload a file"
                        description="description"
                      />
                    </Button>
                  </Paper>
                </div>
              )}
            </Dropzone>
          )}
        </DialogContent>

        {/* {notFormErrors.length > 0 && (
          <DialogContent>
            {notFormErrors.map(err => (
              <Typography color="error" key={err.field + err.code}>
                {getExportErrorMessage(err, intl)}
              </Typography>
            ))}
          </DialogContent>
        )} */}

        {getFile && !loading && (
          <DialogActions>
            <Button onClick={handleClose} data-test="cancel" id="cancelBtn">
              <FormattedMessage {...buttonMessages.cancel} />
            </Button>
            <Button
              onClick={() => onSubmit(getFile, isOverwrite)}
              color="primary"
              variant="contained"
              data-test="next"
              id="salesUploadFileBtn"
            >
              <FormattedMessage {...buttonMessages.upload} />
            </Button>
          </DialogActions>
        )}
      </>
    </Dialog>
  );
};

SalesBulkUploadDialog.displayName = "SalesBulkUploadDialog";
export default SalesBulkUploadDialog;
